import { User } from "src/app/models/user";

export class AssetComments {
    public _id: string;
    public subject: string;
    public description: string;
    public createdByUser: string;
    public createdOn: Date;
    public user: User;
    public userName: String;
    public forAssetVersion: number;
    public displayEdit: boolean;
    public commenterProfile?: string;
}